var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var CommonUtils = require('../../utils/common-utils.js');

var ExternalIdsView = Marionette.View.extend({
    template: require('../../templates/common/external-ids-view.html'),

    ui: {
        table: '#external-ids-table',
        addNewButton: '#add-new-external-id',
        saveButton: '#save-external-ids',
        cancelButton: '#cancel-external-ids-save',

        editButton: '.external-id-edit',
        removeButton: '.external-id-remove',
        externalIdTextInput: '.external-id-text'
    },

    events: {
        'click @ui.addNewButton': 'onAddNewClick',
        'click @ui.editButton': 'onEditClick',
        'click @ui.removeButton': 'onRemoveClick',
        'keyup @ui.externalIdTextInput': 'onExternalIdTextInputKeyUp',
        'click @ui.saveButton': 'onSaveClick',
        'click @ui.cancelButton': 'onCancelClick'
    },

    initialize: function (options) {
        this.externalIds = options.externalIds;
        this.externalIdsOriginal = _.clone(this.externalIds);
    },

    templateContext: function () {
        var that = this;
        return {
            externalIds: that.externalIds
        }
    },

    onRender: function () {
        this.checkAddNewButton();
        this.checkSaveAndCancelButtons();
        this.checkForNewExternalId();

        //var val = event.target.getAttribute('rel-id');
    },

    onAddNewClick: function () {
        this.externalIds.push('');
        this.triggerMethod('on:save:externalids', {
            externalIds: this.externalIds,
            doSave: false
        });
    },

    checkAddNewButton: function () {
        if (this.externalIds.filter(function (id) {
                return _.isEmpty(id);
            }).length > 0) {
            this.ui.addNewButton.attr('disabled', true);
        } else {
            this.ui.addNewButton.removeAttr('disabled');
        }
    },

    checkSaveAndCancelButtons: function () {
        if (_.isEqual(this.externalIdsOriginal,
                this.externalIds)) {
            this.ui.saveButton.attr('disabled', true);
            this.ui.cancelButton.attr('disabled', true);
        } else {
            this.ui.saveButton.removeAttr('disabled');
            this.ui.cancelButton.removeAttr('disabled');
        }
    },

    checkForNewExternalId: function () {
        var indexOfAddedNew = null;
        _.each(this.externalIds, function (externalId, indx) {
            if (_.isEmpty(externalId) && indexOfAddedNew == null)
                indexOfAddedNew = indx;
        });

        if (indexOfAddedNew == null) return;

        var rowOfAddedNew = this.ui.table.find("tr:last");
        this.activeEditInput(rowOfAddedNew);
    },

    onEditClick: function (event) {
        var self = $(event.target);
        var tr = self.closest('tr');
        this.activeEditInput(tr);
    },

    onRemoveClick: function (event) {
        var self = $(event.target);
        var tr = self.closest('tr');
        var firstTd = tr.find('td:eq(0)');
        var span = firstTd.children('span');
        var removedValue = span.text();

        this.externalIds = _.reject(this.externalIds, function(id) {
            return id === removedValue;
        });
        tr.remove();

        this.checkAddNewButton();
        this.checkSaveAndCancelButtons();
    },

    activeEditInput: function (tr) {
        this.inactiveAllInputs();
        var firstTd = tr.find('td:eq(0)');
        var span = firstTd.children('span');
        var input = firstTd.children('input');
        span.hide();
        input.show();
        this.currentEditingExternalId = input.val();
    },

    inactiveAllInputs: function () {
        $('input[type=text]').hide();
        $('span.text').show();
        this.currentEditingExternalId = null;
    },

    onExternalIdTextInputKeyUp: function (event) {
        var self = $(event.target);
        var newValue = self.val();
        if (event.keyCode == 13 && this.currentEditingExternalId != null && !_.isEmpty(newValue)) {
            var currentIndex = _.indexOf(this.externalIds, this.currentEditingExternalId);
            if (currentIndex >= 0) {
                this.externalIds[currentIndex] = newValue;
                self.hide();
                var span = self.parent().children('span.text');
                span.text(newValue);
                span.show();
                this.currentEditingExternalId = null;

                this.checkAddNewButton();
                this.checkSaveAndCancelButtons();
            }
        }
    },

    onSaveClick: function() {
        this.triggerMethod('on:save:externalids', {
            externalIds: this.externalIds,
            doSave: true
        });
    },

    onCancelClick: function() {
        this.triggerMethod('on:cancel:externalids');
    }
});

module.exports = ExternalIdsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/external-ids-view.js
// module id = 274
// module chunks = 0